// Riferimento canonico per nomi eventi e chiavi parametri della tracciatura.
// I wrapper usano EVENTS.* per i nomi evento (è lì che un typo romperebbe il
// match coi trigger GTM); le chiavi parametro restano letterali negli oggetti
// per leggibilità, con PARAMS come riferimento documentato e per i nuovi eventi.

export const EVENTS = {
  PAGE_VIEW: 'page_view',
  SELECT_CONTENT: 'select_content',
  PHOTO_ZOOM: 'photo_zoom',
  IMAGE_OPEN_ORIGINAL: 'image_open_original',
  IMAGE_DOWNLOAD: 'image_download',
  ESSAY_READ_PROGRESS: 'essay_read_progress',
  AUDIOGUIDE_PLAY: 'audioguide_play',
  AUDIOGUIDE_PROGRESS: 'audioguide_progress',
  AUDIOGUIDE_COMPLETE: 'audioguide_complete',
  ITINERARY_STEP_VIEW: 'itinerary_step_view',
  MAP_MARKER_CLICK: 'map_marker_click',
  LANGUAGE_CHANGE: 'language_change',
  SEARCH: 'search',
  VIEW_SEARCH_RESULTS: 'view_search_results',
  FILTER_APPLY: 'filter_apply',
  GATED_ACTION_BLOCKED: 'gated_action_blocked',
  GATED_CONTENT_VIEW: 'gated_content_view',
  SIGN_UP_START: 'sign_up_start',
  SIGN_UP: 'sign_up',
  NEWSLETTER_OPT_IN: 'newsletter_opt_in',
  LOGIN: 'login',
  FAVORITE: 'favorite',
  BOOKMARK: 'bookmark',
  SHARE: 'share',
  FACEBOOK_CTA_CLICK: 'facebook_cta_click',
  DONATE_CLICK: 'donate_click',
  CUSTOM_EVENT: 'custom_event',
  SORT_APPLY: 'sort_apply',
  PAGE_CHANGE: 'page_change',
  COOKIE_CONSENT: 'cookie_consent',
  PAGE_NOT_FOUND: 'page_not_found',
  AUTH_ERROR: 'auth_error',
} as const;

const PARAMS = {
  CONTENT_TYPE: 'content_type',
  CONTENT_ID: 'content_id',
  CONTENT_NAME: 'content_name',
  LIST_NAME: 'list_name',
  INDEX: 'index',
  PERCENT: 'percent',
  SEARCH_TERM: 'search_term',
  RESULTS_COUNT: 'results_count',
  FILTER_TYPE: 'filter_type',
  FILTER_VALUE: 'filter_value',
  GATED_FEATURE: 'gated_feature',
  SOURCE: 'source',
  METHOD: 'method',
  IS_NEW_USER: 'is_new_user',
  USER_ID: 'user_id',
  REGISTRATION_SOURCE: 'registration_source',
  SOCIAL_PROVIDER: 'social_provider',
  SOCIAL_NETWORK: 'social_network',
  SOCIAL_ACTION: 'social_action',
  ACTION: 'action',
  FAVORITE_CONTEXT: 'favorite_context',
  BOOKMARK_CONTEXT: 'bookmark_context',
  MARKER_TYPE: 'marker_type',
  ITEM_ID: 'item_id',
  ITEM_NAME: 'item_name',
  ITEM_URL: 'item_url',
  CONTENT_URL: 'content_url',
  PHOTO_ID: 'photo_id',
  PHOTO_TITLE: 'photo_title',
  PHOTO_URL: 'photo_url',
  ENTITY_ID: 'entity_id',
  ENTITY_TITLE: 'entity_title',
  ENTITY_URL: 'entity_url',
  PAGE_TYPE: 'page_type',
  // Legacy mantenuti solo per custom_event
  EVENT_ACTION: 'event_action',
  EVENT_CATEGORY: 'event_category',
  EVENT_LABEL: 'event_label',
} as const;
